import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { Context } from "../../../../../store/store";
import {
  INTRO_MODULE_SUB_URL,
  INTRO_SUB_URL,
  START_SESSION_ID_SUB_URL,
  TOPIC_SELECTION_SUB_URL,
} from "../../../constants";
import { BottomBar } from "../../components/bottom-bar";
import { canStartTest } from "../../utils";
import Button from "./../../components/button";
import { StoreContextType } from "@/store/types";
import { Module } from "../../../../../constants";
import { useUrlState } from "../../hooks";
import { StaticIntroType } from "./../../types";

import "./styles.scss";

export function ModuleIntro() {
  const { t } = useTranslation();
  const [state] = useContext<StoreContextType>(Context as any);
  const { module, sessionId, navigateToParticipationPage } = useUrlState();
  const { publicTest } = state;
  const { sets, reflectionTestSets, solutionTestSets } = publicTest;

  const startHtml = useMemo(() => {
    if (module === Module.Analytics) {
      return publicTest.startHtml;
    }

    if (module === Module.Reflection) {
      return publicTest.module2StartHtml;
    }

    if (module === Module.Solution) {
      return publicTest.module3StartHtml;
    }

    return "";
  }, [module, publicTest]);

  function navigateToTestSet() {
    const useNewSessionId = sessionId === START_SESSION_ID_SUB_URL;
    const newSessionId = useNewSessionId ? uuidv4() : sessionId;

    let testSets = sets;
    if (module === Module.Reflection) {
      testSets = reflectionTestSets;
    } else if (module === Module.Solution) {
      testSets = solutionTestSets;
    }

    const {
      info: { infoParticipation },
      _id: testSetId,
      items,
    } = testSets[0];

    navigateToParticipationPage({
      sessionId: newSessionId,
      subPage: testSetId,
      subStep: infoParticipation ? INTRO_SUB_URL : items[0]._id,
    });
  }

  const onNextButtonClick = () => {
    if (module === Module.Reflection) {
      navigateToParticipationPage({
        module: INTRO_MODULE_SUB_URL,
        subPage: StaticIntroType.Leverages,
      });
    } else if (module === Module.Solution) {
      navigateToParticipationPage({ subPage: TOPIC_SELECTION_SUB_URL });
    } else {
      navigateToTestSet();
    }
  };

  return (
    <div className="tg_page tg_page-layout tg_module_intro">
      <div className="tg_main tg_column">
        <div
          className="tg_info tg_test-welcome-html tg_test-info"
          dangerouslySetInnerHTML={{
            __html: startHtml,
          }}
        />
      </div>
      <div className="tg_module-intro-actions tg_column">
        {module === Module.Analytics ? (
          <Button
            large
            onClick={onNextButtonClick}
            disabled={!canStartTest(state.publicTest)}
          >
            {t("frontend.test.startTestButtonText", "Start")}
          </Button>
        ) : (
          <Button large onClick={onNextButtonClick}>
            {t("frontend.test.nextTestSetButtonText")}
          </Button>
        )}
      </div>
      <BottomBar />
    </div>
  );
}
